import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'
import { createRetryPromise } from 'core/utils/promise'

import { ShipmentsRepository } from '../infra/shipment/ShipmentsRepository'

type GetShipmentFactoryDependencies = {
  shipmentsRepository: ShipmentsRepository
}

export function getShipmentFactory({ shipmentsRepository }: GetShipmentFactoryDependencies) {
  return function getShipment(shipmentId: string, config?: { signal: AbortSignal }) {
    return shipmentsRepository.getShipment(shipmentId, config)
  }
}

const retryGetShipment = createRetryPromise(error => error?.response?.status === 403, {
  waitTime: 500,
})

export function getShipment(shipmentId: string, config?: { signal: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)
  const shipmentsRepository = new ShipmentsRepository({ httpClient })
  const get = getShipmentFactory({ shipmentsRepository })

  return retryGetShipment(() => get(shipmentId, config))
}
